import SearchSiteFormContainer from 'components/SearchSiteForm/SearchSiteFormContainer'

export default {
  Container: SearchSiteFormContainer,
}
